import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../../-LazyRoutePage"

const DocumentPWPage = lazy(() =>
  import("../../../../../components/WMS/Transfers/PW/DocumentPWPage.tsx").then(
    (module) => ({ default: module.DocumentPWPage }),
  ),
)

type PWDocumentSearch = {
  tab: "general" | "info" | "files"
  edit?: 1
}

export const Route = createFileRoute("/_layout/WMS/documents/doc-pw/$docPw")({
  validateSearch: (search: Record<string, unknown>): PWDocumentSearch => {
    const tab =
      search.tab === "info"
        ? "info"
        : search.tab === "files"
          ? "files"
          : "general"
    return {
      tab,
      ...(search.edit === 1 || search.edit === "1" ? { edit: 1 } : {}),
    }
  },
  component: DocumentPWRoute,
})

function DocumentPWRoute() {
  return (
    <LazyRoutePage>
      <DocumentPWPage />
    </LazyRoutePage>
  )
}
